import { TemplatesResources } from '../templates/templates-config.service';
import { StringErrorUtility } from '../utilities/string-error.utility';
import { KnownAreas } from './../instrumentation/instrumentation.service';
import { FetchStrategy } from './../instrumentation/instrumented-http.service';
import { GraphGetOneNoteNotebooksResponse } from './../models/onenote-graph.model';
import { GetNotebookFetchStrategy, OneNoteGraphService } from './../services/onenote-graph.service';
import { LocService } from './../shared-context/loc.service';
import { InputDialogModel, InputValidationResult } from './input-dialog.component';

export class InputDialogFactory {
    public static createOnenoteNotebookDialog(locService: LocService,
        templatesResources: TemplatesResources,
        oneNoteGraphService: OneNoteGraphService,
        inputButtonExecuteAction: (filename: string) => void,
        dialogDismissAction?: () => void) {

        const STRING_VALIDATORS: ReadonlyArray<(input: string) => InputValidationResult> = [
            (input: string) => StringErrorUtility.isNotEmptyString(input) ? null : { isValid: false, message: '' },
            (input: string) => StringErrorUtility.hasNoInvalidCharacter(input, ['?', '*', '\\', '/', ':', '<', '>', '|', '\'']) ? null : { isValid: false, message: locService.CreateNewNoteBookNameInvalidChars },
            (input: string) => StringErrorUtility.isNotStartingWithSpace(input) ? null : { isValid: false, message: locService.CreateNewNoteBookNameCannotStartWithSpace },
            (input: string) => StringErrorUtility.isContainingLessThanLimitedCharacters(input, 128) ? null : { isValid: false, message: locService.CreateNewNoteBookNameExceeds128Chars }
        ];

        const getNoteBooksHelper = strategy => {
            inputDialogModel.inputValidator = (input: string) => processAll(input, [ ...STRING_VALIDATORS]);
            oneNoteGraphService.getNoteBooks(strategy).results.toPromise().then((res: GraphGetOneNoteNotebooksResponse) => {
                if (res && res.value && res.value.length) {
                    const stringValidators = [].concat(STRING_VALIDATORS);
                    stringValidators.push(input => StringErrorUtility.hasNoDuplicates(input, res.value.map(n => n.displayName), true) ? null : { isValid: false, message: locService.CreateNewNoteBookNameAlreadyExist });
                    inputDialogModel.inputValidator = (input: string) => processAll(input, stringValidators);
                }
            });
        };

        const inputDialogModel: InputDialogModel = {
            title : templatesResources.CreateNewBlankText,
            placeholder: templatesResources.CreateFileDialogOneNoteInputPlaceholder,
            dismissAction: dialogDismissAction
        };

        const processAll = (input: string, stringValidators) => {
            for (const v of stringValidators) {
                const result = v(input);
                if (result) {
                    return result;
                }
            }
            return { isValid: true, message: '' };
        };

        inputDialogModel.inputValidator = (input: string) => processAll(input, [...STRING_VALIDATORS]);
            getNoteBooksHelper(GetNotebookFetchStrategy.CacheFirst);
            inputDialogModel.inputButtonModel = {
                executeAction: (filename: string) => {
                    inputButtonExecuteAction(filename);
                    getNoteBooksHelper(FetchStrategy.NetworkFirst);
                },
                text: locService.CreateFileDialogButtonText
            };
            inputDialogModel.componentArea = KnownAreas.Templates;

        return inputDialogModel;
    }
}
